import { EditorState, Modifier, RichUtils } from 'draft-js'
import { INLINE_TYPES } from '../toolbar/constants'
// original code from https://github.com/jpuri/draftjs-utils/blob/9e2fc49b0d2291f4417366e5eed2dc3b74756976/js/inline.js
// relies on its own customStyleMap and has its own set of bugs and cannot be directly used in our code
export const toggleCustomInlineStyle = (
  editorState: EditorState,
  customStyleMap: Record<string, any>,
  styleType: string,
  style: string,
): any => {
  // get list of the styles of the same family(fontsize-, color-, etc) for removal
  const styleTypeKeys = Object.keys(customStyleMap).filter(
    t => t.indexOf(styleType.toLowerCase()) === 0,
  )
  // remove styles of the same family
  const nextContentState = styleTypeKeys.reduce((contentState, s) => {
    return Modifier.removeInlineStyle(
      contentState,
      editorState.getSelection(),
      s,
    )
  }, editorState.getCurrentContent())
  let nextEditorState = EditorState.push(
    editorState,
    nextContentState,
    'change-inline-style',
  )
  const currentStyle = editorState.getCurrentInlineStyle()
  // collapsed selections(achor = focus/no selection) require extra care,
  // as their styles are kept internally by the editor
  const colapsedSelection = editorState.getSelection().isCollapsed()

  if (colapsedSelection) {
    nextEditorState = currentStyle.reduce((state, s) => {
      if (s.indexOf(styleType.toLowerCase()) === 0)
        return RichUtils.toggleInlineStyle(state, s)
      return state
    }, nextEditorState)
  }

  // finally apply chosen style
  if (!currentStyle.has(`${styleType}-${style}`)) {
    nextEditorState = RichUtils.toggleInlineStyle(
      nextEditorState,
      `${styleType.toLowerCase()}-${style}`,
    )
  }

  return nextEditorState
}
export function removeAllInlineStyles(
  editorState: EditorState,
  customStyleMap: Record<string, any>,
): any {
  // you can't rely on editorState.getCurrentInlineStyle() to get all styles in selection
  // because current != all, so manually construct styles to remove from the known inline styles we have
  const knownInlineStyles = [
    ...Object.keys(customStyleMap),
    ...INLINE_TYPES.map(t => t.style),
  ]
  const contentState = knownInlineStyles.reduce((contentState, style) => {
    return Modifier.removeInlineStyle(
      contentState,
      editorState.getSelection(),
      style,
    )
  }, editorState.getCurrentContent())
  let nextEditorState = EditorState.push(
    editorState,
    contentState,
    'change-inline-style',
  )
  // handle collapsed selection (reset styles when nothing is selected)
  const colapsedSelection = editorState.getSelection().isCollapsed()

  if (colapsedSelection) {
    const currentStyle = editorState.getCurrentInlineStyle()
    nextEditorState = currentStyle.reduce(
      (state, s) => RichUtils.toggleInlineStyle(state, s),
      nextEditorState,
    )
  }

  return nextEditorState
}
